export const CSS_LAYER = {
    base: 'bge-component-bases',
    components: 'bge-components',
    ui: 'bge-ui',
};
export const BLOCK_OPTION_CSS_CUSTOM_PROPERTY_PREFIX = '--bge-options-';
export const BLOCK_OPTION_SCOPE_SELECTOR = `[data-bge-container]`;
